module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5d3949c26ee9df35dfc3699d356edd5b.png";